import type { ErrorPayload } from '@atlaskit/report-error';
import { reportError } from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';

export function platformErrorHandler(payload: ErrorPayload) {
	reportError(payload.error, payload.errorInfo, { id: payload.interactionId });
}
